module.exports = __webpack_public_path__ + "static/media/menu-entities.b8e1c717.svg";